/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type TopLogProb = {
  token: string;
  logprob: number;
  bytes: Array<number>;
};

/** @internal */
export const TopLogProb$inboundSchema: z.ZodType<
  TopLogProb,
  z.ZodTypeDef,
  unknown
> = z.object({
  token: z.string(),
  logprob: z.number(),
  bytes: z.array(z.number()),
});
/** @internal */
export type TopLogProb$Outbound = {
  token: string;
  logprob: number;
  bytes: Array<number>;
};

/** @internal */
export const TopLogProb$outboundSchema: z.ZodType<
  TopLogProb$Outbound,
  z.ZodTypeDef,
  TopLogProb
> = z.object({
  token: z.string(),
  logprob: z.number(),
  bytes: z.array(z.number()),
});

export function topLogProbToJSON(topLogProb: TopLogProb): string {
  return JSON.stringify(TopLogProb$outboundSchema.parse(topLogProb));
}
export function topLogProbFromJSON(
  jsonString: string,
): SafeParseResult<TopLogProb, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TopLogProb$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TopLogProb' from JSON`,
  );
}
